import React from 'react';

export function StatusBadge({ status }) {
  const getStatusConfig = (s) => {
    switch (s?.toLowerCase()) {
      case 'new':
        return { label: 'New', color: '#1D4ED8', bg: '#EFF6FF' };
      case 'qualified':
        return { label: 'Qualified', color: '#0F766E', bg: '#F0FDFA' };
      case 'contacted':
        return { label: 'Contacted', color: '#6D28D9', bg: '#F5F3FF' };
      case 'site_visit':
      case 'site visit':
        return { label: 'Site Visit', color: '#B45309', bg: '#FEF3C7' };
      case 'proposal':
        return { label: 'Proposal', color: '#C2410C', bg: '#FFEDD5' };
      case 'leased':
      case 'lease signed':
        return { label: 'Lease Signed', color: '#15803D', bg: '#DCFCE7' };
      case 'lost':
        return { label: 'Lost', color: '#B91C1C', bg: '#FEE2E2' };
      default:
        return { label: s || 'Unknown', color: '#4B5563', bg: '#F3F4F6' };
    }
  };

  const config = getStatusConfig(status);

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
        fontSize: '12px',
        fontWeight: 600,
        color: config.color,
        backgroundColor: config.bg,
        padding: '3px 8px',
        borderRadius: '9999px'
      }}
    >
      <span style={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: config.color }}></span>
      <span>{config.label}</span>
    </span>
  );
}

export function ChannelBadge({ channel }) {
  const getChannelStyle = (ch) => {
    switch (ch?.toLowerCase()) {
      case 'line':
        return { color: '#00B900', bg: '#E6F9E6', label: 'LINE' };
      case 'facebook':
        return { color: '#1877F2', bg: '#E8F2FE', label: 'Facebook' };
      case 'google':
        return { color: '#0F766E', bg: '#CCFBF1', label: 'Google' };
      case 'tiktok':
        return { color: '#000000', bg: '#F4F4F5', label: 'TikTok' };
      case 'website':
        return { color: '#4F46E5', bg: '#EEF2FF', label: 'Website' };
      case 'referral':
        return { color: '#7C3AED', bg: '#F3E8FF', label: 'Referral' };
      case 'email':
        return { color: '#D97706', bg: '#FEF3C7', label: 'Email' };
      default:
        return { color: '#4B5563', bg: '#F3F4F6', label: channel || 'Direct' };
    }
  };

  const style = getChannelStyle(channel);

  return (
    <span
      style={{
        fontSize: '11.5px',
        fontWeight: 600,
        color: style.color,
        backgroundColor: style.bg,
        padding: '2px 8px',
        borderRadius: '4px',
        display: 'inline-block'
      }}
    >
      {style.label}
    </span>
  );
}

export function ScoreBadge({ score }) {
  const getColor = (sc) => {
    if (sc >= 85) return '#0F766E';
    if (sc >= 70) return '#1D4ED8';
    if (sc >= 50) return '#B45309';
    return '#B91C1C';
  };

  return (
    <span
      style={{
        fontSize: '13px',
        fontWeight: 700,
        fontFamily: 'var(--font-mono)',
        color: getColor(score)
      }}
    >
      {score}
    </span>
  );
}
